<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Carte des prix de la ville</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_city_map.png" class="img-fluid"/>
        <div class="col-12" *ngIf="!preview">
            <mat-form-field>
                <mat-label>Typologie</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="selectedType" (ngModelChange)="onTypeChange()">
                    <mat-option value="B">Tout</mat-option>
                    <mat-option value="A">Appartement</mat-option>
                    <mat-option value="M">Maison</mat-option>
                    <mat-option value="T">Terrain</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="map-container"></div>
    </div>
</div>
